// InPlanBanner — peach editorial banner shown on Mode 1 home and program
// detail pages whenever the member has any selections in the application
// tray. Per IA correction spec §4 and §5: the banner is the bridge that
// prevents members from feeling lost between browse and the Plan tab.
//
// Behavior depends on whether the current page already represents one of
// the selected programs:
//   • currentProgramSlug present + matches a tray item →
//       "★ THIS PROGRAM IS IN YOUR PLAN / Currently selected: {tier} tier"
//       buttons: VIEW PLAN  ·  CONTINUE BROWSING
//   • currentProgramSlug present but NOT a tray item (or undefined) →
//       "★ YOU HAVE {N} PROGRAM(S) IN YOUR PLAN"  buttons: VIEW PLAN
import { Link } from "react-router-dom";
import { C } from "@/lib/brand";
import { useApplicationTray } from "@/lib/applicationTray";

export default function InPlanBanner({ currentProgramSlug }) {
  const { items } = useApplicationTray();
  if (items.length === 0) return null;

  const current = currentProgramSlug
    ? items.find((it) => it.programSlug === currentProgramSlug)
    : null;

  return (
    <div
      data-testid="in-plan-banner"
      style={{
        background: C.peach,
        color: C.peachDark,
        padding: "20px 24px",
      }}
    >
      <div
        style={{
          maxWidth: 1100,
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 16,
          flexWrap: "wrap",
        }}
      >
        <div style={{ minWidth: 0 }}>
          {current ? (
            <>
              <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: "0.2em", color: C.peachDark }}>
                ★ THIS PROGRAM IS IN YOUR PLAN
              </div>
              <div style={{ marginTop: 6, fontSize: 14, color: C.ink }}>
                Currently selected:{" "}
                <strong style={{ fontWeight: 800 }}>{current.tierName} tier</strong>
              </div>
            </>
          ) : (
            <>
              <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: "0.2em", color: C.peachDark }}>
                ★ YOU HAVE {items.length} PROGRAM{items.length === 1 ? "" : "S"} IN YOUR PLAN
              </div>
              <div style={{ marginTop: 6, fontSize: 14, color: C.ink, fontFamily: '"Instrument Serif", Georgia, serif', fontStyle: "italic" }}>
                Pay one review fee to apply for all selected programs.
              </div>
            </>
          )}
        </div>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
          <Link
            to="/app/plan"
            data-testid="in-plan-banner-view"
            style={{
              padding: "10px 18px",
              background: C.ink,
              color: C.cream,
              fontSize: 11,
              fontWeight: 800,
              letterSpacing: "0.2em",
              textDecoration: "none",
              textTransform: "uppercase",
            }}
          >
            VIEW PLAN →
          </Link>
          {current && (
            <Link
              to="/app/browse"
              data-testid="in-plan-banner-browse"
              style={{
                padding: "10px 18px",
                background: "transparent",
                color: C.ink,
                fontSize: 11,
                fontWeight: 800,
                letterSpacing: "0.2em",
                textDecoration: "none",
                textTransform: "uppercase",
                border: `1.5px solid ${C.ink}`,
              }}
            >
              CONTINUE BROWSING
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
